import React from "react";
import Pill from "../../ui/atoms/Pill";

interface RolePillProps {
  role: string;
}

const RolePill: React.FC<RolePillProps> = ({ role }) => {
  return <Pill className="role-pill">{role}</Pill>;
};

export default RolePill;
